import { Injectable } from '@angular/core';
import { AuthServiceProvider } from '../auth-service/auth-service';
import { DataBaseProvider } from '../data-base/data-base';

/*
 contains business rules
*/
@Injectable()
export class BusinessProvider {

  constructor(public $auth: AuthServiceProvider,
    public $db: DataBaseProvider) {

  }

  insertBilling(billingData): Promise<any> {
    const estimateCode = this.getCurrentEstimateCode();
    billingData.estimateNumber = estimateCode;
    billingData.owner = this.$auth.getCurrentUserKey();
    const promise = this.$db.insertBillInfo(billingData);
    promise.then(_ => {
      this.incrementBillNumber();
    })
    return promise;
  }


  getCurrentEstimateCode() {
    const tenantCode = this.$auth.getCurrentUserInfo().tenantCode ? this.$auth.getCurrentUserInfo().tenantCode : 'CCC'
    return (tenantCode + '-' + this.$auth.getCurrentUserInfo().billNumber);
  }

  incrementBillNumber(): Promise<any> {
    let userInfo = this.$auth.getCurrentUserInfo();
    userInfo.billNumber = userInfo.billNumber + 1;
    return this.$db.updateUserInfo(userInfo, this.$auth.getCurrentUserKey());
  }
}



// WEBPACK FOOTER //
// ./src/providers/business/business.ts